export const RIDER_BUSINESS_CONTEXT_KEY = "rider_business_context";

export function readRiderBusinessId() {
  try {
    const value = Number(localStorage.getItem(RIDER_BUSINESS_CONTEXT_KEY));
    return Number.isInteger(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
}

export function writeRiderBusinessId(businessId) {
  const value = Number(businessId);
  if (!Number.isInteger(value) || value <= 0) {
    throw new Error("Invalid rider business context");
  }
  localStorage.setItem(RIDER_BUSINESS_CONTEXT_KEY, String(value));
  return value;
}

export function clearRiderBusinessId() {
  try {
    localStorage.removeItem(RIDER_BUSINESS_CONTEXT_KEY);
  } catch {
    // Storage may be unavailable; in-memory guard state is still cleared.
  }
}

export function resolveExplicitRiderBusinessId(selectedBusinessId, memberships = []) {
  const selected = Number(selectedBusinessId);
  if (!Number.isInteger(selected) || selected <= 0) return null;
  return memberships.some((membership) => Number(membership?.id) === selected)
    ? selected
    : null;
}

